import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { Button, CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

let adicionarTodasEscolasAtivas = false;

export default function Geracao({history}) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [gerando, setGerando] = useState(false);
  const [escolasBusca, setEscolasBusca] = useState([]);
  const [escolasSelecionadas, setEscolasSelecionadas] = useState([]);
  const [escolaFiltro, setEscolaFiltro] = useState([]);

  const carregarEscolas = (param) => {
    api
      .get("escolas/listar", { nome: param.escola })
      .then((res) => {
        setEscolasBusca(res);
      })
      .catch((err) => {
        notification("error", "Erro ao listar os escolas.");
      });
  };

  const fEscolas = {
    title: "Selecionar escolas",
    form: {
      escola: {
        label: "Nome fantasia",
        type: "text",
        value: escolaFiltro,
      },
    },

    submit: {
      label: "buscar",
      // auto: true,
      action: carregarEscolas,
    },

    customActions:
      escolasSelecionadas.length === 0
        ? [
            {
              label: "Adicionar para todas as escolas ativas",
              action: () => {
                setGerando(true);
                adicionarTodasEscolasAtivas = true;
              },
            },
          ]
        : undefined,
  };

  const adicionarEscola = (escola) => {
    if (escolasSelecionadas.filter((e) => e.id === escola.id).lenght > 0)
      return notification("warning", "Escola já adicionada.");

    const escolasBuscaAtualizada = escolasBusca.filter(
      (e) => e.id !== escola.id
    );

    const escolasSelecionadasAtualizada = [...escolasSelecionadas];

    escolasSelecionadasAtualizada.push(escola);

    setEscolasBusca(escolasBuscaAtualizada);
    setEscolasSelecionadas(escolasSelecionadasAtualizada);
  };

  const tBusca = {
    title: "Escolas localizadas",
    array: escolasBusca,
    columns: [
      {
        name: "nomeFantasia",
        label: "Nome fantasia",
        style: { fontWeight: "bolder" },
      },
    ],
    actions: [
      {
        name: "add",
        icon: "zmdi zmdi-plus",
        action: adicionarEscola,
      },
    ],
  };

  const remover = (escolaId) => {
    // const { adicionarTodasEscolasAtivas, escolasSelecionadas } = this.state;

    const escolasSelecionadasAtualizada = escolasSelecionadas.filter(
      (escola) => escola.id !== escolaId
    );

    setEscolasSelecionadas(escolasSelecionadasAtualizada);
    // this.setState({ escolasSelecionadas: escolasSelecionadasAtualizada });
  };

  const tEscolasAdicionar = {
    title: "Criar para as escolas",
    // newItemAction: adicionarEscolas ? undefined : () => this.setState({adicionarEscolas: true}),
    key: "id",
    columns: [
      {
        name: "nomeFantasia",
        label: "Nome fantasia",
        type: "text",
      },
    ],
    actions: [
      {
        name: "delete",
        icon: "zmdi zmdi-delete",
        action: remover,
      },
    ],
    // array: adicionarTodasEscolasAtivas ? [{escolaId: 0, escolaNomeFantasia: '(Todas escolas ativas)'}] : escolasSelecionadas
    array: escolasSelecionadas,
  };

  const inserirVoucher = (param) => {
    const escolas = [];

    escolasSelecionadas.forEach((e) => escolas.push(e.id));
    api
      .put("vouchersFreteGratis/inserir", {
        paraTodasEscolasAtivas: adicionarTodasEscolasAtivas,
        escolasIds: escolas,
        validade: param.validade,
        anotacao: param.anotacao,
      })
      .then((res) => {
        notification("success", "Voucher adicionado!");
        setGerando(false);
        history.goBack()
        // setEscolasBusca(res);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Ids de escolas não informados");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fVoucher = {
    title: "Dados Do Voucher",
    form: {
      validade: {
        label: "Validade",
        type: "date",
        // value: escolaFiltro,
      },
      anotacao: {
        label: "Anotação",
        type: "textarea",
        // value: escolaFiltro,
      },
    },

    submit: {
      label: "salvar",
      // auto: true,
      action: inserirVoucher,
    },

    close: {
      label: "Fechar",
      action: () => {
        setGerando(false);
        adicionarTodasEscolasAtivas = false;
      },
    },
  };

  return (
    <div>
      {!gerando ? (
        <>
          <Form formData={fEscolas} />

          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tBusca} />
          )}
          <br />
          <ActionTable structure={tEscolasAdicionar} />
          <br />
          <Button
            variant="contained"
            color="info"
            sx={{ color: "#FFFF" }}
            onClick={() => setGerando(true)}
          >
            Preencher voucher
          </Button>
        </>
      ) : (
        <>
          <br />
          <Button
            variant="contained"
            sx={{ color: "#FFFF" }}
            onClick={() => setGerando(false)}
          >
            +
          </Button>
          <br />
          <br />
          <ActionTable structure={tEscolasAdicionar} />
          <br />
          <Form formData={fVoucher} />
        </>
      )}
    </div>
  );
}
